import getConfig from '~/config';
import { mapboxGlyphs } from '../common';

const config = getConfig();

const sessionUrl = `https://tile.googleapis.com/v1/createSession?key=${config.googleMapsApiToken}`;

const style = {
  name: 'Satellite (Google)',
  layers: [
    {
      id: 'googleSatellite',
      maxzoom: 23,
      minzoom: 0,
      source: 'googleSatellite',
      type: 'raster',
    },
  ],
  sources: {
    googleSatellite: {
      attribution: 'Source: Google',
      copyrightText: 'Source: Google',
      maxzoom: 23,
      minzoom: 0,
      tileSize: 256,
      tiles: ['https://tile.googleapis.com/v1/2dtiles/{z}/{x}/{y}?session=abcw&key=def'],
      type: 'raster',
    },
  },
  version: 8,
  glyphs: mapboxGlyphs,
};

export async function bootstrap() {
  return await fetch(sessionUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      mapType: 'satellite',
      language: 'en-us',
      region: 'US',
    }),
  })
    .then((r) => r.json())
    .then((data) => {
      if (!data.session) {
        throw new Error('No session token received from Google');
      }

      const url = `https://tile.googleapis.com/v1/2dtiles/{z}/{x}/{y}?session=${data.session}&key=${config.googleMapsApiToken}`;
      return {
        ...style,
        sources: {
          ...style.sources,
          googleSatellite: {
            ...style.sources.googleSatellite,
            tiles: [url],
          },
        },
      };
    })
    .catch((err) => {
      console.error('Error bootstrapping Google tiles: ', err);
      return undefined;
    });
}
